import React from 'react';
import { WrappedButton } from '../button';

const Footer = ({ primary, secondary, children, className = '' }) => (
	<div className={`common-ui-layout-footer ${className}`}>
		{(primary || secondary) && (
			<div className="button-container">
				{primary && <WrappedButton buttonType="primary" {...primary} />}
				{secondary && <WrappedButton buttonType="secondary" {...secondary} />}
			</div>
		)}
		{children && <div className="content-container">{children}</div>}
	</div>
);

export default Footer;
